<router-outlet></router-outlet>
<div>
    <app-footer></app-footer>
</div>
